package ru.villawonka.app.data.interceptor

import io.ktor.client.plugins.HttpSend
import io.ktor.client.plugins.ServerResponseException
import io.ktor.client.request.bearerAuth
import io.ktor.http.HttpStatusCode
import ru.villawonka.app.data.repository.AuthRepository

fun HttpSend.installAuthInterceptor(authRepository: AuthRepository) {
    intercept { request ->
        val token = authRepository.token ?: authRepository.refreshToken()

        if (token != null) request.bearerAuth(token)
        val originalCall = execute(request)

        if (originalCall.response.status == HttpStatusCode.Unauthorized) {
            val newToken = authRepository.refreshToken()
                ?: throw ServerResponseException(
                    response = originalCall.response,
                    cachedResponseText = originalCall.response.status.description
                )

            request.bearerAuth(newToken)
            execute(request)
        } else {
            originalCall
        }
    }
}

